module.exports = global.config = {
    mainTitle: "PSP 5",
    proxy: "https://psp-5.opole.pl",
    menuItems: [],
    isMobile: false,
    isContrasted: false
};